import React, { useContext, useState, useEffect, Fragment } from 'react';
import { Eye } from 'react-feather';
import { Card, CardBody, CardHeader, Col, Row, Container, Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import DataTable from 'react-data-table-component';
import NotificationContext from '../../../_helper/Notification';
import { Breadcrumbs, H5, P } from '../../../AbstractElements';
import { toast } from 'react-toastify';
import { formatDistanceToNow } from 'date-fns';
import { tr } from 'date-fns/locale';

const timeAgo = (dateString) => {
    if (!dateString) return '';
    try {
        return formatDistanceToNow(new Date(dateString), { addSuffix: true, locale: tr });
    } catch (error) {
        console.error("Error formatting time ago:", dateString, error);
        return '';
    }
};

const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
        return new Date(dateString).toLocaleDateString('tr-TR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (error) {
        console.error("Error formatting date:", dateString, error);
        return '';
    }
};

const Notifications = () => {
    const {
        allNotifications,
        loading,
        getNotifications,
        totalRows,
        GetNotificationById
    } = useContext(NotificationContext);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);    
    
    useEffect(() => {
        getNotifications({ page, pageSize });
    }, [page, pageSize]);

    const handleViewNotification = async (id) => {
        setDetailLoading(true);
        try {
            const notification = await GetNotificationById(id);
            if (notification) {
                setSelectedNotification(notification);
                setModalOpen(true);
            }
        } catch (error) {
            toast.error('Bildirim detayları yüklenirken hata oluştu.');
        } finally {
            setDetailLoading(false);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedNotification(null);
    };

    const columns = [
        {
            name: 'Başlık',
            selector: row => row.title,
            sortable: true,
            wrap: true,
            cell: row => (
                <div style={{ fontWeight: row.isRead ? 'normal' : 'bold' }}>
                    {row.title || '-'}
                </div>
            )
        },
        {
            name: 'Mesaj',
            selector: row => row.message,
            sortable: false,
            wrap: true,
            cell: row => (
                <div style={{ fontWeight: row.isRead ? 'normal' : 'bold', whiteSpace: 'normal' }}>
                    {row.message}
                </div>
            )
        },
        {
            name: 'Bildirim Tarihi',
            selector: row => row.created,
            sortable: true,
            format: row => timeAgo(row.created)
        },
        {
            name: 'Durum',
            selector: row => row.isRead,
            sortable: true,
            center: true,
            cell: row => row.isRead ? <span className="badge badge-light-secondary">Okundu</span> : <span className="badge badge-light-primary">Yeni</span>
        },        {
            name: 'İşlemler',
            button: true,
            center: true,
            cell: (row) => (
                <Button
                    size="sm"
                    color="transparent"
                    className="p-1"
                    onClick={() => handleViewNotification(row.id)}
                    title="Bildirim detayını görüntüle"
                    disabled={detailLoading}
                    style={{ border: 'none', background: 'transparent' }}
                >
                    <Eye size={18} className="text-muted" />
                </Button>
            ),
        }
    ];

    return (
        <>
            <Breadcrumbs parent='Bildirim Alanı' title='Tüm Bildirimler' />
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                                <H5>Tüm Bildirimler</H5>
                                <span>Tüm bildirimleriniz aşağıda listelenmektedir.</span>
                            </CardHeader>
                            <CardBody>
                                <Fragment>
                                    <DataTable
                                        columns={columns}
                                        data={allNotifications}
                                        progressPending={loading}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setPage(page)}
                                        onChangeRowsPerPage={pageSize => { setPage(1); setPageSize(pageSize); }}
                                        striped
                                        highlightOnHover
                                        noDataComponent={<div className="p-4 text-center">Bildirim bulunmamaktadır.</div>}
                                        conditionalRowStyles={[
                                             {
                                                 when: row => !row.isRead,
                                                 style: {
                                                     fontWeight: 'bold',
                                                 },
                                             },
                                         ]}
                                    />
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>            {/* Bildirim Detay Modal */}
            <Modal isOpen={modalOpen} toggle={closeModal} size="lg" backdrop="static">
                <ModalHeader toggle={closeModal} className="d-flex justify-content-between align-items-start">
                    {selectedNotification && formatDate(selectedNotification.created) && (
                        <span className="text-muted small">{formatDate(selectedNotification.created)}</span>
                    )}
                </ModalHeader>                <ModalBody>
                    {selectedNotification ? (
                        <div>
                            <H5 className="modal-title me-auto mb-3">{selectedNotification.title}</H5>
                            
                            <P style={{ whiteSpace: 'pre-wrap' }}>
                                {selectedNotification.message}
                            </P>

                            {selectedNotification.details && (
                                <div className="mt-3">
                                    <P style={{ whiteSpace: 'pre-wrap' }}>
                                        {selectedNotification.details}
                                    </P>
                                </div>
                            )}

                            {selectedNotification.priority && selectedNotification.priority !== 'normal' && (
                                <div className="mt-3">
                                    <span className={`badge ${
                                        selectedNotification.priority === 'high' ? 'badge-light-danger' :
                                        selectedNotification.priority === 'medium' ? 'badge-light-warning' :
                                        'badge-light-info'
                                    }`}>
                                        {selectedNotification.priority === 'high' ? 'Yüksek Öncelik' :
                                         selectedNotification.priority === 'medium' ? 'Orta Öncelik' : 
                                         selectedNotification.priority}
                                    </span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center p-4">
                            <span className="text-muted">Bildirim detayları yükleniyor...</span>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeModal}>
                        Kapat
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Notifications;